import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import { fetchRefiTransaction } from './refiTransactionsActions'
import { selectRefiTransaction } from '../../reducers'
import { RefiTransaction } from './types'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import Loader from '../../components/loader'

import { updateRefiLoanTerm } from '../refiApp/refiActions'
import EditLoanTermForm from '../../components/editLoanTermForm'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchRefiTransaction: Callback<Promise<any>>
  updateRefiLoanTerm: Callback<Promise<any>>
  refiTransaction: RefiTransaction
  match: Match<ParamsID>
  history: History
}

export class refiTransactionsEditLoanTerm extends Component<Props> {
  static displayName = 'refiTransactionsEditLoanTerm'

  state = {
    isLoading: false,
    newLoanTerm: null,
  }

  componentWillMount() {
    this.fetchRefi()
  }

  onTermChange = (value: number) => {
    this.setState({ newLoanTerm: value })
  }

  fetchRefi = () => {
    const { fetchRefiTransaction, match } = this.props
    fetchRefiTransaction(match.params && match.params.id)
  }

  onSubmit = () => {
    const { match, history, updateRefiLoanTerm } = this.props

    const toSubmit = {
      id: Number(match.params.id),
      term: Number(this.state.newLoanTerm),
    }

    this.setState({ isLoading: true })

    return updateRefiLoanTerm(toSubmit)
      .then(() => {
        history.push({ pathname: `/refinance/${match.params.id}` })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  backToIndex = () => {
    this.props.history.goBack()
  }

  render() {
    const { refiTransaction } = this.props
    const { isLoading } = this.state

    return (
      <Fragment>
        <TransitionGroup>
          {isLoading && (
            <CSSTransition
              classNames="slow-fade"
              timeout={{
                enter: 200,
                exit: 500,
              }}
            >
              <div className="loading-overlay">
                <Loader isLoading={true} className="loading-overlay__loader" />
                <p className="loading-overlay__text">
                  Please wait... It will take a minute.
                </p>
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
        <EditLoanTermForm
          onSubmit={this.onSubmit}
          cancel={this.backToIndex}
          currentLoanTerm={refiTransaction.term}
          onTermChange={this.onTermChange}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = (state, { match }) => {
  return {
    refiTransaction: selectRefiTransaction(
      state.refiTransactions,
      match.params.id
    ),
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateRefiLoanTerm: (term) => dispatch(updateRefiLoanTerm(term)),
  fetchRefiTransaction: (id) => dispatch(fetchRefiTransaction(id)),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(refiTransactionsEditLoanTerm)
)
